const style = {
  simpleRow: {
    display: 'flex',
    flexDirection: 'row',
    minWidth: 0,
  },
  simpleColumn: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },
  spacedBetweenRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    minWidth: 0,
  },
  responsesContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    overflowY: 'scroll',
    marginTop: 10,
  },
  filterItem: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 10,
    paddingBottom: 10,
    cursor: 'pointer',
  },
  centeredText: {
    width: '100%',
    textAlign: 'center',
  },
  filterButtonText: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'center',
    minWidth: 0,
    // width: 'calc(100% - 45px)',
  },
  clickable: {
    cursor: 'pointer',
  },
  viewToggleButton: {
    width: 40,
    marginBottom: 0,
  },
  modalHeaderActions: {
    position: 'absolute',
    right: 70,
    top: 8,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    height: 31,
  },
  distributionQuestionCard: {
    marginTop: 20,
    border: '1px solid #d3d6db',
    borderRadius: 4,
    backgroundColor: '#f7f8fa',
    paddingBottom: 8,
  },
  distributionQuestionHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #d3d6db',
    padding: 10,
    fontWeight: 600,
  },
  distributionRows: {
    display: 'flex',
    flexDirection: 'column',
    padding: '8px 10px',
    gap: 8,
  },
  distributionRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    border: '2px solid #1e1f22',
    minHeight: 39,
    padding: 5,
    backgroundColor: 'var(--rr-surface)',
    overflow: 'hidden',
  },
  distributionLabel: {
    width: 110,
    minWidth: 110,
    paddingLeft: 10,
    fontWeight: 600,
    fontSize: 13,
  },
  distributionTrack: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    backgroundColor: '#f1f2f4',
  },
  distributionFill: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#000000',
    fontWeight: 700,
    fontSize: 14,
    minHeight: 35,
  },
  distributionZeroLabel: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    minHeight: 35,
    color: '#000000',
    fontWeight: 700,
    fontSize: 14,
  },
  distributionEmptyState: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 80,
    color: '#5d6168',
    fontStyle: 'italic',
  },
};
export default style;
